export const BusinessConfig = [
  {
    title: '隐私政策',
    content: '隐私政策',
    url: 'https://m.xiaomiyoupin.com/content/ewen/pageFromId?id=jazizae6ehd0mtv6&spmref=0.0.0.0.16310973661545810',
    pcurl: 'https://m.xiaomiyoupin.com/content/ewen/pageFromId?id=jazizae6ehd0mtv6&spmref=0.0.0.0.16310973661545810',
  },
  {
    title: '小米有品用户协议',
    content: '隐私政策',
    url: 'https://m.xiaomiyoupin.com/mr/60013c77c9e77c0001f35060',
  },
  {
    title: '小米账号使用协议',
    content: '隐私政策',
    url: 'https://m.xiaomiyoupin.com/mr/60014809cff47e0001f66ad6',
  },
];
